import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]

  connect() {
    this.searchTimeout = null
    document.addEventListener('click', this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.closeResults()
    }
  }

  search(event) {
    const query = event.target.value.trim()

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }

    if (query.length < 2) {
      this.closeResults()
      return
    }

    this.searchTimeout = setTimeout(() => {
      this.performSearch(query)
    }, 300)
  }

  performSearch(query) {
    fetch(`/patients/search?query=${encodeURIComponent(query)}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(response => response.json())
    .then(patients => {
      this.renderResults(patients)
    })
    .catch(error => {
      console.error('Error searching patients:', error)
    })
  }

  renderResults(patients) {
    if (patients.length === 0) {
      this.resultsTarget.innerHTML = '<div class="navbar-search-no-results">No se encontraron pacientes</div>'
    } else {
      this.resultsTarget.innerHTML = patients.map(patient => {
        const details = [patient.email, patient.dni ? `DNI: ${patient.dni}` : null].filter(Boolean).join(' · ')
        return `<a href="/patients/${patient.id}" class="navbar-search-result">
          <div class="navbar-search-result-name">${patient.full_name}</div>
          ${details ? `<div class="navbar-search-result-details">${details}</div>` : ''}
        </a>`
      }).join('')
    }
    this.resultsTarget.classList.remove('d-none')
  }

  closeResults() {
    if (this.hasResultsTarget) {
      this.resultsTarget.classList.add('d-none')
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.closeResults()
      this.inputTarget.blur()
    }
  }
}
